module.exports = __webpack_public_path__ + "img/05.908c4196.png";